import { Component, EventEmitter, Input } from '@angular/core';

import { Field } from '@site-mate/dashpivot-shared-library';

import { SettingsActionFieldNames } from './settings-action-field-names.enum';

export interface IFieldSettingsAction {
  icon: string;
  label: string;
  isVisible: boolean;
  fieldName: SettingsActionFieldNames;
  onUpdate: EventEmitter<any>;
}

@Component({
  selector: 'cc-template-field-settings',
  templateUrl: './template-field-settings.component.html',
  styleUrls: ['./template-field-settings.component.scss'],
})
export class TemplateFieldSettingsComponent {
  @Input() field: Field;
  @Input() actions: IFieldSettingsAction[];

  isExpanded = false;

  handleExpandableState() {
    this.isExpanded = !this.isExpanded;
  }
}
